<template>
  <section id="section__404" class="view-container">
    <div class="width-100">
      <v-row no-gutters class="mt-10 mb-10">
        <v-col cols="12">
          <LogoText />
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col cols="12">
          <img src="@/assets/images/error/500error.png" class="error-img" alt="404" />
          <p class="font--m-1">500 ERROR</p>
          <p class="font--m-3">죄송합니다.</p>
          <p class="font--m-5">요청하신 페이지를 찾지 못했습니다.</p>
          <router-link :to="{ name: 'main' }" id="btn__pMKgP/AHj0GJkjktrczJIg=="
            >메인으로 이동</router-link
          >
        </v-col>
      </v-row>
    </div>
  </section>
</template>

<script>
export default {
  metaInfo() {
    return this.metaInfo
  },
  created() {},
}
</script>
<style lang="scss" scoped>
#section__404 {
  text-align: center;

  .error-img {
    width: 80px;
    height: 170px;
  }
}
</style>
